/**
 * Dummy data — 배너
 * BE: /api/admin/banners (CRUD) / /api/main/banners (Public)
 */

const banners = [
  { id: 1, title: '공항 배너', image_url: '/images/banner/Banner01.png', image_mobile_url: '/images/banner/Banner03.png', service: 'airport', link_url: 'signup-coupon:VIPWELCOME', is_active: true, sort_order: 1, start_date: null, end_date: null, created_at: '2026-01-01T00:00:00+09:00', updated_at: null },
  { id: 2, title: '골프 배너', image_url: '/images/banner/Banner02.png', image_mobile_url: null, service: 'golf', link_url: null, is_active: true, sort_order: 2, start_date: null, end_date: null, created_at: '2026-01-01T00:00:00+09:00', updated_at: null },
  { id: 3, title: '리조트 배너', image_url: '/images/banner/Banner04.png', image_mobile_url: null, service: 'resort', link_url: null, is_active: true, sort_order: 3, start_date: null, end_date: null, created_at: '2026-01-01T00:00:00+09:00', updated_at: null },
  { id: 4, title: '병원 배너', image_url: '/images/banner/Banner05.png', image_mobile_url: null, service: 'hospital', link_url: null, is_active: true, sort_order: 4, start_date: null, end_date: null, created_at: '2026-01-01T00:00:00+09:00', updated_at: null },
  { id: 5, title: '반려동물 배너', image_url: '/images/banner/Banner06.png', image_mobile_url: null, service: 'pet', link_url: null, is_active: true, sort_order: 5, start_date: null, end_date: null, created_at: '2026-01-01T00:00:00+09:00', updated_at: null },
  { id: 6, title: '비즈니스 배너', image_url: '/images/banner/Banner03.png', image_mobile_url: null, service: 'business', link_url: null, is_active: true, sort_order: 6, start_date: null, end_date: null, created_at: '2026-01-01T00:00:00+09:00', updated_at: null },
];

function delay(ms) { return new Promise((r) => setTimeout(r, ms)); }

/* ── 관리자 ── */

export const adminGetBanners = async (params = {}) => {
  await delay(200);
  const items = [...banners];
  return { items, total: items.length, page: params.page || 1, size: params.size || 20, pages: 1 };
};

export const adminCreateBanner = async (data) => {
  await delay(300);
  const newBanner = {
    id: Math.max(0, ...banners.map((b) => b.id)) + 1,
    ...data,
    is_active: data.is_active !== false,
    sort_order: Number(data.sort_order) || 0,
    created_at: new Date().toISOString(),
    updated_at: null,
  };
  banners.push(newBanner);
  return newBanner;
};

export const adminUpdateBanner = async (id, data) => {
  await delay(300);
  const idx = banners.findIndex((b) => b.id === Number(id));
  if (idx === -1) throw new Error('배너를 찾을 수 없습니다.');
  banners[idx] = { ...banners[idx], ...data, updated_at: new Date().toISOString() };
  return banners[idx];
};

export const adminDeleteBanner = async (id) => {
  await delay(200);
  const idx = banners.findIndex((b) => b.id === Number(id));
  if (idx === -1) throw new Error('배너를 찾을 수 없습니다.');
  banners.splice(idx, 1);
  return { message: '배너가 삭제되었습니다.' };
};

// #241: 더미 환경에서는 자동번역 no-op.
export const adminAutoTranslateBanner = async () => {
  await delay(100);
  return [];
};

/* ── 공개 ── */

export const getMainBanners = async () => {
  await delay(100);
  return banners.filter((b) => b.is_active);
};

export const getServiceBanner = async (service) => {
  await delay(100);
  // BE 공개 라우터와 동일 규칙: is_active + 노출기간(start~end) + 서비스
  const today = new Date().toISOString().slice(0, 10);
  const inWindow = (b) => (!b.start_date || b.start_date <= today) && (!b.end_date || b.end_date >= today);
  const list = banners.filter((b) => b.is_active && inWindow(b) && (!service || b.service === service || b.service == null));
  return list[0] || null;
};
